import styled from 'styled-components';

import { COLOR } from 'styles/styledComponents/color.model';

export const ActionLink = styled.div`
  font-size: 12px;
  line-height: 15px;
  font-weight: normal;
  color: ${COLOR.OUTER_SPACE};
  &:hover {
    color: ${COLOR.CHEMISTRY};
    svg {
      fill: ${COLOR.CHEMISTRY};
    }
  }
  svg {
    transition: fill 0.3s;
  }
`;
